/**
 * True when the OS has been asked to minimise animation, so motion can be skipped or a
 * transition-length wait dropped. Deliberately import-free: callers include modules that must
 * not pull the store into their dependency graph.
 *
 * `matchMedia` is guarded for jsdom, where it exists only because setupTests polyfills it.
 */
export const prefersReducedMotion = () =>
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
